export const BackendAPI = {
  // orders
  orders: "/order/orders",
  adminOrders: "/order/admin_orders",
  getOrder: (orderId: string) => `/order/${orderId}`,
  priceList: (customerCode: string) => `/order/price_list/${customerCode}`,
  allPriceList: "/order/price_list",
  refreshKdStatus: "/kingdee/refresh_kd_status",
  uploadKdOrders: "/kingdee/upload_kd",
  orderHistory: (orderId: string) => `/order/${orderId}/history`,
  auditOrder: (orderId: string) => `/order_audit/${orderId}/audit`,
  cancelOrder: `/order_audit/cancel`,
  ordersWarehouseEnter: `/order_audit/warehouse_enter`,
  shipOrders: `/order_audit/ship`,
  // upload orders
  updateOrderBilling: (orderId: string) =>
    `/order_audit/${orderId}/update_billing`,
  updateOrderTracking: (orderId: string) =>
    `/order_audit/${orderId}/update_tracking`,
  orderUploadPreview: "/order_upload/upload/preview",
  orderUploadConfirm: "/order_upload/upload/confirm",
  createOrder: "/order_upload/create",
  trackingUploadPreview: "/order_upload/upload_tracking/preview",
  trackingUploadConfirm: "/order_upload/upload_tracking/confirm",
  // export orders
  orderExport: "/order_export/export",
  batchOrderExport: "/order_export/batch_export",
  // users
  customerList: "/customer/list",
  customerAll: "/customer/all",
  matchCustomer: "/customer/match",
  staffList: "/user/list_staff",
  simpleStaffList: "/user/simple_list_staff",
  listSalesperson: "/user/list_salesperson",
  userInfo: "/user/user-info",
  userLogin: "/user/login",
  userRegister: "/user/register",
  userUpdate: "/user/update",
  userPassword: "/user/password",
  createUser: "/user/create",
  banUser: "/user/ban",
  resetUserPassword: "/user/reset-password",
  // API Keys
  apiKeys: "/user/api-keys",
  deleteApiKey: (keyId: string) => `/user/api-keys/${keyId}`,
  // materials
  materialList: "/material/list",
  materialAll: "/material/all",
  createMaterial: "/material/create",
  updateMaterial: (id: string) => `/material/${id}`,
  disableMaterial: (id: string) => `/material/${id}/disable`,
  enableMaterial: (id: string) => `/material/${id}/enable`,
  downloadMaterialList: "/material/download",
  previewStockUpdate: "/material/stock/preview",
  confirmStockUpdate: "/material/stock/confirm",
  // product album
  productAlbumList: "/product_album/listWithFilter",
  productAlbumGetInfo: (materialCode: string) => `/product_album/${materialCode}/info`,
  productAlbumUpdateInfo: (materialCode: string) => `/product_album/${materialCode}/info`,
  productAlbumListImages: (materialCode: string) => `/product_album/${materialCode}/images`,
  productAlbumUploadImages: (materialCode: string) => `/product_album/${materialCode}/images`,
  productAlbumDeleteImage: (imageId: string) => `/product_album/images/${imageId}`,
  productAlbumSetMain: (imageId: string) => `/product_album/images/${imageId}/set_main`,
  productAlbumImport: "/product_album/import",
  productAlbumExport: "/product_album/export",
  productAlbumExportFormats: "/product_album/export_formats",
  productAlbumExportFormat: (formatId: string) => `/product_album/export_formats/${formatId}`,
  // attributes fields
  getAttributeFields: "/attribute/attribute_fields",
  getDefaultPriceAttributeField: "/attribute/attribute_fields/default_price",
  setDefaultPriceAttributeField: "/attribute/attribute_fields/default_price",
  addAttributeField: "/attribute/attribute_fields/add",
  updateAttributeField: "/attribute/attribute_fields/update",
  deleteAttributeField: "/attribute/attribute_fields/delete",
  getAttributeTypeList: "/attribute/attribute_types",
  addAttributeType: "/attribute/attribute_types/add",
  updateAttributeType: "/attribute/attribute_types/update",
  deleteAttributeType: "/attribute/attribute_types/delete",
  updateAttributeFieldsBatch: "/attribute/attribute_fields/update_batch",
  // agents
  uploadAgentToolsData: "/agent_tools/upload/preview",
  confirmAgentToolsData: "/agent_tools/upload/confirm",
  deleteAgentToolsData: "/agent_tools/delete",
  // kingdee
  uploadKdOrdersPreview: "/kingdee/upload_kd/preview",
  uploadKdOrdersConfirm: "/kingdee/upload_kd/confirm",
  syncKdCustomer: "/kingdee/sync_customer",
  syncKdMaterial: "/kingdee/sync_material",
  getKdDataLastSyncTime: "/kingdee/last_sync_time",
  syncKdSalesperson: "/kingdee/sync_salesperson",
  // attributes
  getMaterialAttributes: "/attribute/attributes",
  updateMaterialAttributes: "/attribute/attributes/update",
  getMaterialAttributesHistory: "/attribute/attributes/history",
  exportMaterialAttributes: "/attribute/attributes/export",
  // sync
  lastSyncTime: "/kingdee/last_sync_time",
  syncMaterialList: "/kingdee/sync_material",
  syncCustomerList: "/kingdee/sync_customer",
  syncPriceList: "/kingdee/sync_price_list",
};
